import React, { useState, useEffect } from 'react'
import HeadingArea from '../../general/HeadingArea'
import { AiOutlineSearch } from 'react-icons/ai';
import { FaUserEdit } from 'react-icons/fa';
import ResponseMsg2 from '../../general/ResponseMsg2';
import axios from 'axios';

const TransportReport = ({ setLoading }) => {

  const [searchFilter, setSearchFilter] = useState('');
  const [selectedSection, setSelectedSection] = useState('');
  const [availableSections, setAvailableSections] = useState([]);
  const [selectedClassId, setSelectedClassId] = useState('');
  const [academicYears, setAcademicYears] = useState([]);
  const [selectedAY, setSelectedAY] = useState('');
  const [std, setStd] = useState([]);
  const [classes, setClasses] = useState([]);
  const [showView, setShowView] = useState(false);
  const [selectedStd, setSelectedStd] = useState([]);
      const [assignVehicle, setAssignVehicle] = useState([]);
  const [selectedTransportId, setSelectedTransportId] = useState('');

    const [response2, setResponse2] = useState({ message: '', status: 'success' });


const filteredStd = std.filter(cls => {
  const term = searchFilter.toLowerCase();
  const matchesSearch =
    cls.reg_no.toLowerCase().includes(term) ||
    cls.class_name.toLowerCase().includes(term) ||
    cls.name.toLowerCase().includes(term);

  return matchesSearch;
});


  const handleSearch = async (e) => {
    e.preventDefault();

    if (!selectedAY || !selectedClassId) {
      alert('Please select both Academic Year and Class to search.');
      return;
    }

    setLoading(true);

    try {
      // Get class_name from classId
      const selectedClass = classes.find((cls) => cls.id === Number(selectedClassId));
      const className = selectedClass ? selectedClass.class_name : '';

      // Build query params
      const params = new URLSearchParams();
      params.append('ay', selectedAY);
      params.append('class_name', className);

      if (selectedSection) {
        params.append('section', selectedSection);
      }

      const url = `https://api.kcian.in/get-transport-student?${params.toString()}`;

      const response = await fetch(url);

      if (response.ok) {
        const data = await response.json();
        setStd(data);

      } else {
        console.error('Failed to fetch students');
      }
    } catch (error) {
      console.error('Error fetching students:', error);
    } finally {
      setLoading(false);
    }
  };


  const fetchClasses = async () => {
    setLoading(true);
    try {
      const response = await fetch('https://api.kcian.in/get-classes');
      if (response.ok) {
        const data = await response.json();
        setClasses(data);
      } else {
        console.error('Failed to fetch class');
      }
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setLoading(false);
    }
  };


  const fetchAcademicYears = async () => {
    setLoading(true);
    try {
      const response = await fetch('https://api.kcian.in/get-academic-years');
      if (response.ok) {
        const data = await response.json();
        setAcademicYears(data);
      } else {
        console.error('Failed to fetch academic years');
      }
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchClasses();
    fetchAcademicYears();
    fetchAssignedVehicle();
  }, []);


      const fetchAssignedVehicle = async () => {
          setLoading(true);
          try {
              const res = await axios.get('https://api.kcian.in/fetch-assigned-vehicle');
              setAssignVehicle(res.data);
          } catch (error) {
              console.log(error)
          } finally {
              setLoading(false);
          }
      };

  useEffect(() => {
    if (selectedClassId) {
      const selectedClass = classes.find((cls) => cls.id === Number(selectedClassId));
      if (selectedClass && selectedClass.sections) {
        const sectionArray = selectedClass.sections
          .split(',')
          .map((s) => s.trim())
          .filter((s) => s !== '');
        setAvailableSections(sectionArray);
      } else {
        setAvailableSections([]);
      }
      setSelectedSection('');
    } else {
      setAvailableSections([]);
      setSelectedSection('');
    }
  }, [selectedClassId, classes]);


  
  const handleShowView = (std) => {
setShowView(true);
    setSelectedStd(std);
  }


  const handleAssignTransport = async (e) => {
  e.preventDefault();

  if (!selectedTransportId || !selectedStd.id) {
    setResponse2({ message: 'Please select a transport vehicle.', status: 'error' });
    return;
  }

  setLoading(true);

  try {
    const payload = {
      'std_id': selectedStd.id,
      'vehicle_id': selectedTransportId,
      // 'old_vehicle_id': selectedStd.dor_room_id != null ? selectedStd.dor_room_id : null
    };

    const response = await axios.put('https://api.kcian.in/assign-transport', payload);

    if (response.status === 200) {
      setResponse2({ message: 'Transport assigned successfully!', status: 'success' });
      fetchAssignedVehicle();
      setShowView(false);
    window.location.reload();
    } else {
      setResponse2({ message: 'Something went wrong. Try again.', status: 'error' });
    }
  } catch (error) {
    console.error(error);
  } finally {
        setTimeout(() => setResponse2({ message: '', status: '' }), 3000);
    setLoading(false);
  }
};



  return (
    <>
              <section className='py-4'>
            <div className='px-4'>
        <HeadingArea message1='Transport' message2='Student Transport Report' />


          <form onSubmit={handleSearch} className='profile-card'>
            <span className="profile-heading">Select Criteria</span>

            <div className='d-md-flex d-sm-flex d-block mt-3'>
              <div className="mb-4 w-100 me-3">
                <div className='profile-input-area'>
                  <label className="profile-badge">Select AY*</label>
                  <select
                    className="profile-input"
                    value={selectedAY}
                    onChange={(e) => setSelectedAY(e.target.value)}
                    required
                  >
                    <option value="">-- Select Academic Year --</option>
                    {academicYears.map((ay) => (
                      <option key={ay.year} value={ay.year}>
                        {ay.year} --- {ay.title}
                      </option>
                    ))}
                  </select>
                </div>
              </div>

              <div className="mb-4 w-100 me-3">
                <div className='profile-input-area'>
                  <label className="profile-badge">Select Class*</label>
                  <select
                    className="profile-input"
                    value={selectedClassId}
                    onChange={(e) => setSelectedClassId(e.target.value)}
                    required
                  >
                    <option value="">-- Select Class --</option>
                    {classes.map((cls) => (
                      <option key={cls.id} value={cls.id}>
                        {cls.class_name}
                      </option>
                    ))}
                  </select>
                </div>
              </div>

              <div className="mb-4 w-100">
                <div className='profile-input-area'>
                  <label className="profile-badge">Select Section*</label>
                  <select
                    className="profile-input"
                    value={selectedSection}
                    onChange={(e) => setSelectedSection(e.target.value)}
                    disabled={availableSections.length === 0}
                  >
                    <option value="">-- Select Section --</option>
                    {availableSections.map((section, idx) => (
                      <option key={idx} value={section}>
                        {section}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            </div>

            <div className='text-end'>
              <button type='submit' className='profile-btn2'>
                <AiOutlineSearch /> Search
              </button>
            </div>
          </form>


        <div className='col-xl-9 col-lg-8 col-md-7 col-12 my-2 h-100 w-100 mt-4'>
          <div className='profile-card'>
            <div className='d-md-flex d-sm-flex justify-content-between mb-2'>
              <span className="profile-heading align-content-center">Student Transport Report</span>


              <div className='profile-input-area ms-auto col-lg-3 border-0'>
                <input
                  type='text'
                  name='search'
                  className='profile-input border-bottom rounded-0'
                  placeholder='Search...'
                  value={searchFilter}
                  onChange={(e) => setSearchFilter(e.target.value)}
                />
              </div>
            </div>

            <div className="table-responsive">
              <table className="table w-100 text-center" >
                <thead className="account-thead">
                  <th className='rounded-start-4'>S No</th>
                  <th>Class(Section)</th>
                  <th>Registration  No</th>
                  <th>Student Name</th>
                  <th>Mobile</th>
                  <th>Transport Assigned</th>
                  <th className='rounded-end-4'>Action</th>
                </thead>
                <tbody>
                  {filteredStd.length > 0 ? (
                    filteredStd.map((item, id) => (
                      <tr key={id}>
                        <td>{id + 1}</td>
                        <td>{item.class_name} ({item.section})</td>
                        <td>{item.reg_no}</td>
                        <td>{item.name}</td>
                        <td>{item.mobile}</td>
                        <td>{item.transport_id != null ? 
                        <>Route: {item.route_title} (Fare: ₹{item.route_fare})<br />Vehicle Model: {item.vehicle_model}<br />
                        Vehicle No: {item.vehicle_no}</> : 'No'}</td>
                            <td>
                         <FaUserEdit className='emp-icon bg-primary' title='Assign Room' onClick={() => handleShowView(item)} />                           
                           {/* {item.transport_id == null ? 
                         <FaUserEdit className='emp-icon bg-primary' title='Assign Room' onClick={() => handleShowView(item)} />
                         : '--'} */}
                                                   </td>
                      </tr>
                    ))) :
                    <tr className='account-tr'>
                      <td colSpan="7">
                        No Data found.
                      </td>
                    </tr>
                  }
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      </section>


{showView && (
  <section className='ins-dialog'>
<div className='ins-dialog-inner col-lg-10 col-12 animate__animated animate__fadeInDown mx-auto' onClick={(e) => e.stopPropagation()}>
  <p className='ins-dialog-heading text-danger'>
    {selectedStd.transport_id != null ? 'Re Assign' : 'Assign'} Transport Vehicle to {selectedStd.name} - Class {selectedStd.class_name} ({selectedStd.section})
  </p>

  {response2.message && <ResponseMsg2 message={response2.message} status={response2.status} />}

  <form onSubmit={handleAssignTransport} className='mt-4'>
    <div className='profile-input-area mb-4'>
      <label className='profile-badge'>Select Vehicle*</label>
      <select
        className='profile-input'
        value={selectedTransportId}
        onChange={(e) => setSelectedTransportId(e.target.value)}
        required
      >
        <option value="">-- Select Vehicle --</option>
        {assignVehicle.map((vehicle) => (
          <option key={vehicle.id} value={vehicle.id}>
            {vehicle.vehicle_model} ({vehicle.vehicle_no}) - ₹{vehicle.fare}/Seat
          </option>
        ))}
      </select>
    </div>

    <div className='text-end mt-3'>
      <button type='submit' className='profile-btn me-2'>
        {selectedStd.transport_id != null ? 'Re Assign' : 'Assign'} Transport
      </button>
              <button className='profile-btn2' onClick={() => setShowView(false)}>Go Back</button>

    </div>
  </form>
</div>

</section>
)}



    </>
  )
}

export default TransportReport